import React, { Component } from "react";
import styled from "styled-components";



export default class CapabilitiesItem extends Component {

   render() {

      const CapabilitiesItem = styled.div`
      border: 1px solid rgba(230, 230, 230, 1);
      padding: 2.4rem 1.5rem;
     `

      const CapabilitiesItemImg = styled.div`
      padding-bottom: 1.5rem;
`
      const CapabilitiesItemTitle = styled.div`
padding-bottom: 1rem;
font-weight:700;
text-transform: uppercase;
`
      const CapabilitiesItemText = styled.div`

`

      /* ${this.props.options['img']} */

      return (
         <CapabilitiesItem>
            <CapabilitiesItemImg>
               <img src={require(`./Image__Capabilities-png/${this.props.options['img']}`)} alt="блокнот и стакан с карандашами" />
            </CapabilitiesItemImg>
            <CapabilitiesItemTitle>
               {this.props.options['title']}
            </CapabilitiesItemTitle>
            <CapabilitiesItemText>
               Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat.
            </CapabilitiesItemText>
         </CapabilitiesItem>

      )
   }
}